{
  "commentConditions": "Annetut kommentit julkaistaan {linkToDefinition} Helsingin kaupungin palvelussa {linkToLicense}. Tekstejä voidaan muokata loukkaavan tai muutoin törkeän kielenkäytön osalta.",
  "fullscreenHeaderLogoAlt": "Helsinki logo",
  "footerLogoAlt": "Helsinki logo",
  "headerLogoAlt": "Siirry etusivulle",
  "copyrightHolder": "Helsingin kaupunki",
  "copyrightText": "Kaikki oikeudet pidätetään.",
  "footerCityLink": "www.hel.fi"
}
